import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import updateCountryBusCostEntryMutationV2 from '../graphql/updateCountryBusCostEntryMutationV2';
import {RegionalCostsVehicleCost} from '../store/types';
import {receivedCountryVehicleCostAction} from '../store/slice';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';

interface UseUpdateCountryBusCostEntryV2MutationResult {
  updateCountryBusCostEntry: (
    cost: RegionalCostsVehicleCost,
    countryId: string,
    year: number,
    onSuccess?: (cost?: RegionalCostsVehicleCost) => void
  ) => Promise<void>;
}

export const useUpdateCountryBusCostEntryV2Mutation =
  (): UseUpdateCountryBusCostEntryV2MutationResult => {
    const dispatch = useAppDispatch();
    const [updateCountryBusCostEntryV2] = useMutation(
      updateCountryBusCostEntryMutationV2,
      {
        errorPolicy: 'all'
      }
    );

    const updateCountryBusCostEntry = useCallback(
      async (
        cost: RegionalCostsVehicleCost,
        countryId: string,
        year: number,
        onSuccess?: (cost?: RegionalCostsVehicleCost) => void
      ) => {
        try {
          const variables = {
            ...cost,
            countryId,
            year
          };
          const result = await updateCountryBusCostEntryV2({variables});

          if (result.errors && result.errors.length > 0) {
            const errorMessage = result.errors[0].message;
            console.error(errorMessage);
            return;
          }

          dispatch(
            receivedCountryVehicleCostAction(
              result.data.updateCountryBusCostEntryV2
            )
          );
          onSuccess?.(result.data.updateCountryBusCostEntryV2);
        } catch (err: any) {
          console.error(
            `Unexpected error while updating country bus cost entry: ${err}`
          );
        }
      },
      [dispatch, updateCountryBusCostEntryV2]
    );

    return {updateCountryBusCostEntry};
  };
